module.exports = __webpack_public_path__ + "static/media/1_n.2c32ad24.jpg";